var _path, _line, _line2, _line3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcquisition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1711 7.76154C18.6655 7.58498 18.1125 7.85172 17.9359 8.35733C17.7593 8.86294 18.0261 9.41594 18.5317 9.59251L19.1711 7.76154ZM23.2378 12.0786L24.0449 11.5411L24.0449 11.5411L23.2378 12.0786ZM24.6858 17.4372L25.6538 17.4951L25.6538 17.4951L24.6858 17.4372ZM17.8492 25.4398L17.6409 24.4928L17.8492 25.4398ZM12.3302 24.8465L12.7351 23.9654L12.3302 24.8465ZM8.2853 21.0452L7.43099 21.504L7.43099 21.504L8.2853 21.0452ZM8.30889 15.7228C8.39129 15.1937 8.0291 14.6979 7.49993 14.6155C6.97076 14.5331 6.47499 14.8953 6.39259 15.4245L8.30889 15.7228ZM18.5317 9.59251C20.1258 10.1492 21.4947 11.2108 22.4307 12.6161L24.0449 11.5411C22.8749 9.78438 21.1637 8.45739 19.1711 7.76154L18.5317 9.59251ZM22.4307 12.6161C23.3667 14.0215 23.8186 15.6938 23.7179 17.3793L25.6538 17.4951C25.7798 15.3882 25.2149 13.2977 24.0449 11.5411L22.4307 12.6161ZM23.7179 17.3793C23.6171 19.0648 22.9692 20.6714 21.8724 21.9552L23.347 23.2149C24.7179 21.6102 25.5278 19.6019 25.6538 17.4951L23.7179 17.3793ZM21.8724 21.9552C20.7756 23.239 19.29 24.13 17.6409 24.4928L18.0576 26.3869C20.1189 25.9334 21.976 24.8197 23.347 23.2149L21.8724 21.9552ZM17.6409 24.4928C15.9918 24.8555 14.2694 24.6704 12.7351 23.9654L11.9254 25.7276C13.8432 26.6089 15.9962 26.8403 18.0576 26.3869L17.6409 24.4928ZM12.7351 23.9654C11.2008 23.2604 9.93844 22.074 9.13961 20.5865L7.43099 21.504C8.42952 23.3635 10.0075 24.8464 11.9254 25.7276L12.7351 23.9654ZM9.13961 20.5865C8.34078 19.0989 8.04912 17.3913 8.30889 15.7228L6.39259 15.4245C6.06787 17.51 6.43245 19.6445 7.43099 21.504L9.13961 20.5865Z",
    fill: "#0BC196"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.5148,
    y1: 13.5757,
    x2: 15.5148,
    y2: 19.3938,
    stroke: "#0EF1BC",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.6057,
    y1: 16.4846,
    x2: 18.4239,
    y2: 16.4846,
    stroke: "#0EF1BC",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.969697,
    y1: -0.969697,
    x2: 8.72727,
    y2: -0.969697,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 6.30293 7.93921)",
    stroke: "#0EF1BC",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15143 5.81812L4.15881 8.17568C3.5181 8.68044 3.51089 9.64913 4.14402 10.1634L7.15143 12.606",
    stroke: "#0BC196",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcquisition);
export default __webpack_public_path__ + "static/media/acquisition.1dd0080fd48938711fe025224ed8f34b.svg";
export { ForwardRef as ReactComponent };